import { render } from "./userlogin.vue?vue&type=template&id=4a972137"
import script from "./userlogin.vue?vue&type=script&lang=js"
export * from "./userlogin.vue?vue&type=script&lang=js"

import "./userlogin.vue?vue&type=style&index=0&id=4a972137&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__